import { render } from "./waike.vue?vue&type=template&id=86dda1e0"
import script from "./waike.vue?vue&type=script&lang=js"
export * from "./waike.vue?vue&type=script&lang=js"

import "./waike.vue?vue&type=style&index=0&id=86dda1e0&lang=scss"

import exportComponent from "/home/jenkins/workspace/xujiaxin-linchuang-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__